import { useModal } from "@pulse/hooks/contextHooks";
import { faEnvelopeOpenText } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { Link } from "@tanstack/react-router";
import type { Survey } from "@pulse/api/surveyApi";
import { useSelectedCustomerIdParam } from "@/features/hub/selectedCustomerContext";
import { Button } from "frontend-components";

interface SuccessModalProps {
    survey: Survey;
    failedEmails?: string[];
}

export const SuccessModal = ({ survey, failedEmails = [] }: SuccessModalProps) => {
    const { closeModal } = useModal();
    const { t } = useTranslation();
    const customerId = useSelectedCustomerIdParam();

    return (
        <div className="flex flex-col items-center justify-center w-[500px] max-w-full">
            <div className="p-6">
                <FontAwesomeIcon icon={faEnvelopeOpenText} className="text-6xl" color={"#B7F0CE"} />
            </div>
            <h2 className="text-2xl mb-2">{t("survey.surveyStarted")}</h2>
            <p className="text-center text-on-container/80 mb-8">
                {t("survey.surveyStartedDescription")}
            </p>

            {failedEmails.length > 0 && (
                <div className="mb-8">
                    <h4 className="font-medium text-on-container/60">
                        {t("survey.someInvitationsFailed")} ({failedEmails.length})
                    </h4>
                    <div className="mt-2 max-h-32 overflow-y-auto border border-warning/30 rounded-md bg-warning/5 p-3">
                        <ul className="list-disc pl-5">
                            {failedEmails.map((email, index) => (
                                <li key={index} className="text-sm text-on-container/80 mb-1">
                                    {email}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}

            <div className="w-full flex justify-end">
                <Button
                    variant="fill"
                    onClick={closeModal}
                    render={
                        <Link
                            to="/$customerId/pulse/$pulseId/surveys/$surveyId"
                            params={{
                                customerId,
                                pulseId: String(survey.pulseInstanceId),
                                surveyId: String(survey.id),
                            }}
                        >
                            {t("common.ok")}
                        </Link>
                    }
                >
                    {t("common.ok")}
                </Button>
            </div>
        </div>
    );
};
